// Hit dice by class
export const CLASS_HIT_DICE = {
  Cleric: '1d8',
  Druid: '1d8',
  Fighter: '1d10',
  Paladin: '1d10',
  Ranger: '2d8',
  'Magic-User': '1d4',
  Illusionist: '1d4',
  Thief: '1d6',
  Assassin: '1d6',
  Monk: '2d4'
};

// Race and class compatibility
export const RACE_CLASSES = {
  Dwarf: ['Fighter', 'Thief', 'Assassin'],
  Elf: ['Fighter', 'Magic-User', 'Thief', 'Assassin'],
  Gnome: ['Fighter', 'Thief', 'Illusionist', 'Assassin'],
  'Half-Elf': ['Cleric', 'Fighter', 'Magic-User', 'Thief', 'Assassin'],
  Halfling: ['Fighter', 'Thief'],
  'Half-Orc': ['Cleric', 'Fighter', 'Thief', 'Assassin'],
  Human: ['Cleric', 'Druid', 'Fighter', 'Paladin', 'Ranger', 'Magic-User', 'Illusionist', 'Thief', 'Assassin', 'Monk']
};


// Class ability score requirements (minimums, with 6s changed to 3s, Bard excluded)
export const CLASS_REQUIREMENTS = {
  Cleric: { Str: 3, Int: 3, Wis: 9, Dex: 3, Con: 3, Cha: 3 },
  Druid: { Str: 3, Int: 3, Wis: 12, Dex: 3, Con: 3, Cha: 15 },
  Fighter: { Str: 9, Int: 3, Wis: 3, Dex: 3, Con: 7, Cha: 3 },
  Paladin: { Str: 12, Int: 9, Wis: 13, Dex: 3, Con: 9, Cha: 17 },
  Ranger: { Str: 13, Int: 13, Wis: 14, Dex: 3, Con: 14, Cha: 3 },
  'Magic-User': { Str: 3, Int: 9, Wis: 3, Dex: 3, Con: 3, Cha: 3 },
  Illusionist: { Str: 3, Int: 15, Wis: 3, Dex: 16, Con: 3, Cha: 3 },
  Thief: { Str: 3, Int: 3, Wis: 3, Dex: 9, Con: 3, Cha: 3 },
  Assassin: { Str: 12, Int: 11, Wis: 3, Dex: 12, Con: 3, Cha: 3 },
  Monk: { Str: 15, Int: 3, Wis: 15, Dex: 15, Con: 11, Cha: 3 }
};